import classNames from 'classnames';

import { setupForDark } from '@theme';

function MultipleChoiceStateIcon({
  size = 36,
  selected = false,
  disabled = false,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  selected?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: (event) => void;
}) {
  let els = <></>;
  if (!selected && !disabled) {
    els = (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.5999 3.40039H4.3999C3.84762 3.40039 3.3999 3.84811 3.3999 4.40039V19.6004C3.3999 20.1527 3.84762 20.6004 4.3999 20.6004H19.5999C20.1522 20.6004 20.5999 20.1527 20.5999 19.6004V4.40039C20.5999 3.84811 20.1522 3.40039 19.5999 3.40039ZM4.3999 2.40039C3.29533 2.40039 2.3999 3.29582 2.3999 4.40039V19.6004C2.3999 20.705 3.29533 21.6004 4.3999 21.6004H19.5999C20.7045 21.6004 21.5999 20.705 21.5999 19.6004V4.40039C21.5999 3.29582 20.7045 2.40039 19.5999 2.40039H4.3999Z'
        className={classNames(setupForDark('fill-toggle-btn-unselected'))}
      />
    );
  } else if (selected && !disabled) {
    els = (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.40039 2.40039C3.29582 2.40039 2.40039 3.29582 2.40039 4.40039V19.6004C2.40039 20.705 3.29582 21.6004 4.40039 21.6004H19.6004C20.705 21.6004 21.6004 20.705 21.6004 19.6004V4.40039C21.6004 3.29582 20.705 2.40039 19.6004 2.40039H4.40039ZM17.3301 8.93062C17.623 8.63773 17.623 8.16286 17.3301 7.86996C17.0372 7.57707 16.5624 7.57707 16.2695 7.86996L10.1998 13.9396L7.73013 11.47C7.43724 11.1771 6.96237 11.1771 6.66947 11.47C6.37658 11.7629 6.37658 12.2377 6.66947 12.5306L9.66947 15.5306C9.96237 15.8235 10.4372 15.8235 10.7301 15.5306L17.3301 8.93062Z'
        className={classNames(setupForDark('fill-toggle-btn-selected'))}
      />
    );
  } else if (!selected && disabled) {
    els = (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.5999 3.40039H4.3999C3.84762 3.40039 3.3999 3.84811 3.3999 4.40039V19.6004C3.3999 20.1527 3.84762 20.6004 4.3999 20.6004H19.5999C20.1522 20.6004 20.5999 20.1527 20.5999 19.6004V4.40039C20.5999 3.84811 20.1522 3.40039 19.5999 3.40039ZM4.3999 2.40039C3.29533 2.40039 2.3999 3.29582 2.3999 4.40039V19.6004C2.3999 20.705 3.29533 21.6004 4.3999 21.6004H19.5999C20.7045 21.6004 21.5999 20.705 21.5999 19.6004V4.40039C21.5999 3.29582 20.7045 2.40039 19.5999 2.40039H4.3999Z'
        className={classNames(setupForDark('fill-toggle-btn-unselected-disabled'))}
      />
    );
  } else if (selected && disabled) {
    els = (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.40039 2.40039C3.29582 2.40039 2.40039 3.29582 2.40039 4.40039V19.6004C2.40039 20.705 3.29582 21.6004 4.40039 21.6004H19.6004C20.705 21.6004 21.6004 20.705 21.6004 19.6004V4.40039C21.6004 3.29582 20.705 2.40039 19.6004 2.40039H4.40039ZM17.3301 8.93062C17.623 8.63773 17.623 8.16286 17.3301 7.86996C17.0372 7.57707 16.5624 7.57707 16.2695 7.86996L10.1998 13.9396L7.73013 11.47C7.43724 11.1771 6.96237 11.1771 6.66947 11.47C6.37658 11.7629 6.37658 12.2377 6.66947 12.5306L9.66947 15.5306C9.96237 15.8235 10.4372 15.8235 10.7301 15.5306L17.3301 8.93062Z'
        className={classNames(setupForDark('fill-toggle-btn-selected-disabled'))}
      />
    );
  }

  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        stroke='none'
        fill='none'
      >
        {els}
      </svg>
    </span>
  );
}

export default MultipleChoiceStateIcon;
